import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import React from 'react';
import Login from "./containers/Login";
import ForgotPassword from "./containers/ForgotPassword";
import CreatePassword from "./containers/CreatePassword";
import ResetPassword from "./containers/ResetPassword";
import ActivateAccount from './containers/ActivateAccount'; 
import BookLists from "./containers/BookLists";
import Homepage from "./containers/HomePage";
import Account from "./containers/Account";
import InstantOrder from "./containers/InstantOrder";
import Checkout from "./containers/Checkout";
import ShoppingCart from "./containers/ShoppingCart";
import OrderHistory from "./containers/OrderHistory";
import OrderDetails from "./containers/OrderDetails";
import Support from "./containers/Support";
import DownloadReports from "./admin/DownloadReports";
import NotFound from "./containers/NotFound";
import SearchResults from './containers/SearchResults';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/forgotPassword" element={<ForgotPassword />} />
        <Route path="/createPassword" element={<CreatePassword />} />
        <Route path="/resetPassword/:tokenId" element={<ResetPassword />} />
        <Route path="/activate/:tokenId" element={<ActivateAccount />} />
        <Route path="/list" element={<BookLists />} />
        <Route path="/home" element={<Homepage />} />
        <Route path="/accountDetails" element={<Account />} />
        <Route path="/instantOrder" element={<InstantOrder />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/shoppingCart" element={<ShoppingCart />} />
        <Route path="/orderHistory" element={<OrderHistory />} />
        <Route path="/orderHistory/:orderNo" element={<OrderDetails />} />
        <Route path="/support" element={<Support />} />
        <Route path="/admin" element={<DownloadReports />} />
        {/* <Route path="/admin/user" element={<User />} />
        <Route path="/admin/product" element={<Product />} />
        <Route path="/admin/orderHistory" element={<OrderHistoryAdmin />} />
        <Route path="/admin/cartDetails" element={<CartDetailsAdmin />} />
        <Route path="/productDetailsUpload" element={<ProductDetailsUpload />} />
        <Route path="/productImagesUpload" element={<ImageDetailsUpload />} />
        <Route path="/maintainance" element={<MaintainancePage />} />
        <Route path="/unAuthorized" element={<Unauthorized />} />
        <Route path="/user-cred" element={<AdminCred />} />
        <Route path="/product-cred" element={<ProductRetrieve />} />
        <Route path="/productEdit" element={<EditProduct />} /> */}
        <Route path="/searchResults" element={<SearchResults />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
};

export default App;